import { Close } from "@mui/icons-material";
import {
  CircularProgress,
  Grid,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
} from "@mui/material";
import React from "react";

const columns = [
  { field: "srNo", headerName: "S. NO.", width: 20 },
  { field: "storeName", headerName: "STORE NAME", width: 80 },
  { field: "manager", headerName: "STORE MANAGER", width: 120 },
  { field: "address", headerName: "ADDRESS", width: 250 },
  { field: "pincode", headerName: "PIN CODE", width: 70 },
  { field: "city", headerName: "CITY", width: 80 },
  { field: "state", headerName: "STATE", width: 80 },
  { field: "zone", headerName: "Zone", width: 80 },
  // { field: "productType", headerName: "PRODUCT TYPE", width: 80 },
  // { field: "productWidth", headerName: "WIDTH (ft.)", width: 40 },
  // { field: "productHeight", headerName: "HEIGHT (ft.)", width: 30 },
  // { field: "productThickness", headerName: "THICKNESS (inch.)", width: 20 },
  { field: "soName", headerName: "SO Name", width: 20 },
  { field: "soPhoneNumber", headerName: "SO Phone Number", width: 20 },
];

const LocationsTablesDialog = ({
  isLocationModal,
  locations,
  products,
  setIsLocationModal,
}) => {
  const handleClose = () => {
    setIsLocationModal(false);
  };

  return (
    <Dialog
      open={isLocationModal}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle>
        <div className="flex justify-between items-center">
          <h3>{`Locations : ${locations?.length || 0}`}</h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent dividers sx={{ maxHeight: 600 }}>
        {locations?.length === 0 ? (
          <Box className="border rounded-lg mb-8 shadow-lg bg-white p-10">
            <div className="flex justify-between items-center w-full bg-blue-400 p-2 rounded-t-lg">
              <h1 style={{ color: "inherit" }}>Sites</h1>
            </div>
            <div className="flex justify-center items-center">
              <h3 className="w-full text-center mt-2 p-5">
                There is no location added yet
              </h3>
            </div>
          </Box>
        ) : (
          <Grid
            className="bg-[var(--secondary-color)] shadow-md p-5 border rounded-lg"
            spacing={3}
          >
            <TableContainer
              className="rounded-lg custom-scrollbar"
              sx={{
                overflowY: "auto",
                maxHeight: 500,
              }}
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    {columns?.map((column) => (
                      <TableCell
                        key={column.field}
                        sx={{
                          whiteSpace: "nowrap",
                          fontWeight: "550",
                          backgroundColor: "#e0e0e0",
                          width: column.width,
                        }}
                      >
                        {column.headerName}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {locations.map((location, i) => (
                    <TableRow key={i}>
                      <TableCell>{`${i + 1}.`}</TableCell>
                      <TableCell>
                        {typeof location?.storeName === "string"
                          ? location.storeName
                          : location?.storeName?.richText?.[0]?.text ||
                            "Not Available"}
                      </TableCell>

                      <TableCell>
                        <div className="flex items-center">
                          <div className="ml-2">
                            <span className="block font-medium">
                              {location?.storeOwnerName
                                ? location.storeOwnerName
                                    .charAt(0)
                                    .toUpperCase() +
                                  location.storeOwnerName.slice(1)
                                : "N/A"}
                            </span>
                            <span className="text-gray-400 text-xs">
                              {location?.storeOwnerPhoneNumber ?? "NA"}
                            </span>
                          </div>
                        </div>
                      </TableCell>
                      <TableCell>
                        {typeof location.address === "string"
                          ? location.address
                          : location.address?.richText
                              ?.map((item) => item.text)
                              .join(" ")}
                      </TableCell>
                      <TableCell>{location?.zipCode}</TableCell>
                      <TableCell>
                        {typeof location?.city === "string"
                          ? location.city
                          : location?.city?.richText?.[0]?.text ||
                            "Not Available"}
                      </TableCell>
                      <TableCell>{location?.state}</TableCell>
                      <TableCell>{location?.zone}</TableCell>
                      {/* <TableCell>{products[i]?.productType}</TableCell> */}
                      {/* <TableCell align="center"> */}
                      {/* {products[i]?.productWidth.toFixed(2) || "N/A"} */}
                      {/* </TableCell> */}
                      {/* <TableCell align="center"> */}
                      {/* {products[i]?.productHeight.toFixed(2) || "N/A"} */}
                      {/* </TableCell> */}
                      {/* <TableCell align="center"> */}
                      {/* {products[i]?.productThickness.toFixed(2) || "N/A"} */}
                      {/* </TableCell> */}
                      <TableCell align="center">
                        {location?.soName || "N/A"}
                      </TableCell>
                      <TableCell align="center">
                        {location?.soPhoneNumber || "N/A"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default LocationsTablesDialog;
